const { server_ip }= require('../config');

export async function insertResearchTaskRecord(token, session, taskId, startTime, submitTime, group, data){
    try {
        const response= await fetch(`${server_ip}/api2/researchTaskRecords`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                data:{
                    session, taskId, startTime, submitTime, group, data
                }
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}

export async function studentFetchResearchTaskRecords(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api2/researchTaskRecords/student-fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}
export async function teacherFetchResearchTaskRecords(token,filter,options){
    try {
        const response= await fetch(`${server_ip}/api2/researchTaskRecords/fetch`,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify({
                filter,options
            }),
        })
        return await response.json();
    } catch (error) {
        alert(JSON.stringify(error));
    }
}